import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_N8N_URL,
});

export default client;
